export default __webpack_public_path__ + "static/media/facebook.977b7db2.svg";